import React from 'react';

const AppConfigPage = React.lazy(() => import('pages/AppConfig/AppConfigPage'));
const AppConfigKeyPage = React.lazy(() => import('pages/AppConfigKey/AppConfigKeyPage'));
const AppConfigKeyAddPage = React.lazy(() => import('pages/AppConfigKey/AppConfigKeyAddPage'));

const appConfigRoute = [
  {
    path: '/app-config',
    exact: true,
    name: 'Cài đặt hệ thống',
    function: ['MD_AREA_VIEW', 'SYS_APPCONFIG_VIEW'],
    any: true,
    component: AppConfigPage,
  },
  {
    path: '/app-config-keys',
    exact: true,
    name: 'Key cấu hình',
    function: 'SYS_APPCONFIG_VIEW',
    component: AppConfigKeyPage,
  },
  {
    path: '/app-config-keys/add',
    exact: true,
    name: 'Thêm key cấu hình',
    function: 'SYS_APPCONFIG_ADD',
    component: AppConfigKeyAddPage,
  },
  {
    path: '/app-config-keys/edit/:app_config_id',
    exact: true,
    name: 'Chỉnh sửa key cấu hình',
    function: 'SYS_APPCONFIG_EDIT',
    component: AppConfigKeyAddPage,
  },
  {
    path: '/app-config-keys/detail/:app_config_id',
    exact: true,
    name: 'Chi tiết key cấu hình',
    function: 'SYS_APPCONFIG_VIEW',
    component: AppConfigKeyAddPage,
  },
];

export default appConfigRoute;
